import { Mail } from "lucide-react";
import { MOCKUP_LINK, SITE } from "@/content/site";
import { GlowField } from "@/components/site/GlowField";
import { CTAButton } from "@/components/site/CTAButton";
import { MaskedLines, Reveal } from "@/components/motion/Reveal";

export const FinalCTA = () => (
  <section className="relative isolate overflow-hidden border-t border-white/[0.08] py-28 lg:py-40" data-testid="final-cta-section">
    <GlowField className="glow-bottom" />
    <div className="container-x">
      <Reveal as="p" className="eyebrow">
        Next step
      </Reveal>
      <MaskedLines
        as="h2"
        onView
        lines={["See your new website", "before you commit."]}
        className="mt-6 max-w-5xl text-4xl font-semibold leading-[1.02] tracking-[-0.04em] sm:text-6xl lg:text-7xl"
        lineClassName="text-sheen"
        testId="final-cta-heading"
      />
      <Reveal as="p" delay={0.15} className="mt-8 max-w-xl text-base leading-relaxed text-[#A1A1AA] sm:text-lg">
        Start with a quick 15-minute call. We'll design a free mockup of your new homepage, so you can see it before
        you decide anything.
      </Reveal>
      <Reveal delay={0.25} className="mt-10 flex flex-wrap gap-3">
        <CTAButton to={MOCKUP_LINK} size="lg" testId="final-cta-button">
          Get a free mockup
        </CTAButton>
        <CTAButton href={`mailto:${SITE.email}`} variant="secondary" size="lg" arrow={false} testId="final-cta-email-button">
          <Mail className="h-4 w-4" aria-hidden="true" />
          {SITE.email}
        </CTAButton>
      </Reveal>
    </div>
  </section>
);
